// src/catalogos/estadosMunicipios.js

export const OFICINAS_POR_MUNICIPIO = {
  "Benito Juárez": [
    "Sindicato de Taxistas",
    "Dirección de Tránsito Xcaret",
    "Delegacion Imoveqroo Alcatraces"
  ],

  "Solidaridad": [
    "Dirección de Tránsito Playa del Carmen",
    "Plaza Palmeras"
  ],

  "Tulum": [
    "IMOVEQROO Plaza Andadores"
  ],

  "Cozumel": [
    "Dirección de Tránsito"
  ],

  "Isla Mujeres": [
    "Peninsular Tránsito",
    "Insular Tránsito"
  ],

  "Othon P. Blanco": [
    "Plaza Manatí",
    "OME SRE"
  ],

  "Bacalar": [
    "Dirección de Tránsito"
  ],

  "Jose María Morelos": [
    "Dirección de Tránsito"
  ],

  "Lázaro Cárdenas": [
    "Dirección de Tránsito"
  ],

  "Puerto Morelos": [
    "Dirección de Tránsito"
  ],

  "Carrillo Puerto": [
    "Dirección de Tránsito"
  ],

  "Unidades Móviles": [
    "Unidad Móvil 1",
    "Unidad Móvil 2"
  ]
};
